module.exports = __webpack_public_path__ + "static/media/paginaCursos.a9aad016.png";